import React, { useCallback, useEffect, useState } from "react";
import styled, { withTheme } from "styled-components";
import AlertUGNX from "../../../ToastsAndAlerts/AlertUGNX";
import { AlertType } from "../../../ToastsAndAlerts/constants";
import PrimaryButton from "../../../ui-library/Buttons/PrimaryButton/PrimaryButton";
import CustomPopover from "../../../ui-library/CustomPopover/CustomPopover";
import NullableDateTime from "../../../ui-library/DateAndTime/NullableDateTime/NullableDateTime";

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const InputGroupRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 10px;
`;

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const Label = styled.span`
  color: ${(props) => props.theme?.mortar};
  font-size: 15px;
  font-weight: 600;
`;

const FormActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 20px;
`;

const DateTimeFilterForm = (props) => {
  const {
    show,
    onClose,
    onSubmit,
    currentFilterAfter,
    currentFilterBefore,
    target,
    index,
  } = props;

  const [filterAfter, setFilterAfter] = useState(null);
  const [filterBefore, setFilterBefore] = useState(null);

  const [isValid, setIsValid] = useState(true);

  useEffect(() => {
    setFilterAfter(currentFilterAfter);
  }, [currentFilterAfter]);

  useEffect(() => {
    setFilterBefore(currentFilterBefore);
  }, [currentFilterBefore]);

  useEffect(() => {
    if (
      filterAfter !== null &&
      filterBefore !== null &&
      filterAfter >= filterBefore
    ) {
      setIsValid(false);
    } else {
      setIsValid(true);
    }
  }, [filterBefore, filterAfter]);

  const handleOnClose = useCallback(() => {
    onClose();
    setFilterAfter(currentFilterAfter);
    setFilterBefore(currentFilterBefore);
  }, [onClose, currentFilterAfter, currentFilterBefore]);

  const onKeyDown = (event) => {
    if (event.key === "Enter") {
      onSubmit(filterBefore, filterAfter);
    }
  };

  return (
    <CustomPopover
      show={show}
      target={target}
      onClose={handleOnClose}
      title="Filter by"
    >
      <FormContainer data-testid="date-times-filter-form">
        <InputGroupRow>
          <InputGroup>
            <Label>From (UTC)</Label>
            <NullableDateTime
              data-testid="atf-after-date-time-picker"
              dateTime={filterAfter}
              setDateTime={setFilterAfter}
              onKeyDown={onKeyDown}
            />
          </InputGroup>
          <InputGroup>
            <Label>To (UTC)</Label>
            <NullableDateTime
              data-testid={`atf-before-date-time-picker-${index || 0}`}
              dateTime={filterBefore}
              setDateTime={setFilterBefore}
              onKeyDown={onKeyDown}
            />
          </InputGroup>
        </InputGroupRow>
        {!isValid && (
          <AlertUGNX data-testid="error-alert" type={AlertType.DANGER}>
            Error: The "To" timestamp cannot be before the "From" timestamp.
          </AlertUGNX>
        )}
        <FormActionButtonsContainer>
          <PrimaryButton
            data-testid={`date-times-filter-modal-submit-button-${index || 0}`}
            size="sm"
            disabled={!isValid}
            onClick={() => {
              onSubmit(filterBefore, filterAfter);
            }}
          >
            Apply
          </PrimaryButton>
        </FormActionButtonsContainer>
      </FormContainer>
    </CustomPopover>
  );
};

export default withTheme(DateTimeFilterForm);
